import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ChangeKeyDataContMain from "presentation/view/container/ChangeKeyData/ChangeKeyDataContMain";

CommonEntrypoint(<ChangeKeyDataContMain/>)